export const showExercise = (exercise) => {
  document.querySelector(
    ".question"
  ).textContent = exercise.multiplication.split("").join(" ");
  document.querySelector(".answer").textContent = exercise.answer;
};
